import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { zenCardMotion } from './motion';
import { zenChromeTone } from './palette';

export const zenTheme: FlowThemeDefinition = {
  id: 'zen',
  label: 'Zen Garden',
  description: 'Set a stone in a raked dry garden with every step, from morning mist to a lantern-lit finish.',
  category: 'daylight',
  chromeTone: zenChromeTone,
  swatch: 'linear-gradient(180deg, #C6D3E0 0%, #EDE6DA 38%, #E3D3BC 70%, #C9472E 100%)',
  cardGlass: 'default',
  cardMotion: zenCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createZenScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
